import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { makeStyles, Theme, Typography } from '@material-ui/core';
import { IBreadcrumb } from 'common/interfaces/common';

const useStyles = makeStyles((theme: Theme) => ({
  breadcrumb: {
    '&:hover': {
      color: theme.palette.text.primary,
    },
  },
}));

interface IBreadcrumbProps {
  breadcrumb: IBreadcrumb;
  inactive?: boolean;
}

const Breadcrumb: FC<IBreadcrumbProps> = ({ breadcrumb, inactive = false }) => {
  const intl = useIntl();
  const classes = useStyles();
  const labelParts: string[] = [];

  if (typeof breadcrumb.label === 'string') {
    labelParts.push(breadcrumb.label);
  } else if (typeof breadcrumb.label === 'object') {
    labelParts.push(intl.formatMessage(breadcrumb.label));
  }

  if (breadcrumb.labelPostfix) {
    labelParts.push(breadcrumb.labelPostfix);
  }

  const content = (
    <Typography variant="subtitle2" color="inherit">
      {labelParts.join(' - ')}
    </Typography>
  );

  if (inactive || !breadcrumb.path) {
    return content;
  }

  return (
    <Link to={breadcrumb.path} id={breadcrumb.id} className={classes.breadcrumb} type="button">
      {content}
    </Link>
  );
};

export default Breadcrumb;
